module.exports = new __parcel__URL__("base_raid_attack_btn.819cc3db.png").toString();